import styled from 'styled-components';
import { Orientation, DeviceType } from 'sofa-reborn-react';
import { ITheme } from '@inter-ikea-kompis/types';

export const StyledActionButtons = styled.div<{
	orientation: Orientation;
	deviceType: DeviceType;
	theme: ITheme;
}>`
	height: ${(props) => (props.deviceType === 'mobile' ? '100%' : 'auto')};
	width: ${(props) => (props.deviceType === 'mobile' ? '100%' : 'auto')};
	display: flex;
	justify-content: center;
	align-items: center;
	flex-wrap: ${(props) =>
		props.deviceType === 'mobile' && props.orientation === 'portrait' ? 'wrap' : 'nowrap'};
	flex-direction: ${(props) =>
		props.deviceType === 'mobile' && props.orientation === 'landscape' ? 'column' : 'row'};

	#rotateButton {
		margin: ${(props) => props.theme.spacing.space25 / 16}rem;
	}
	[data-element-name='kompis-icon-pill'] {
		margin: ${(props) => props.theme.spacing.space25 / 16}rem;
	}
	[data-element-name='kompis-icon-pill-group'] {
		margin: 0
			${(props) =>
				props.deviceType === 'mobile' && props.orientation === 'landscape'
					? props.theme.spacing.space150 / 16
					: 0}rem;
		justify-content: center;
	}
`;
